var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('span',{staticClass:"octadesk-app-join-room"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$sanitizeHtml(_vm.$t('conversation.leave', { date: _vm.leaveDate })))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }